import MoveToBank from '../components/moveToBank/index';
import ChannelWalletLedger from '../components/reports/channelWalletLedger';
import SettleToBank from '../components/settleToBank/index';
import SettleToWallet from '../components/settleToWallet';
import fingAepsComponent from '../components/aepsFingpay';
import instantAepsComponent from '../components/aepsInstant';
import MoneyTransfer from '../components/moneyTransfer';
import RegisterMatm from '../components/serviceMATM/registerMatm';
import mobileRecharge from '../components/mobileRecharge';
import uitilityPayment from '../components/uitilityPayment';
import uitilityPayment2 from '../components/uitilityPayment2';
import BharatBillpay from '../components/bharatBillpay';
import CommissionRelease from '../components/commissionRelease/index';
import BankSetting from '../components/banksetting';
import PartnerEKYC from '../components/partnerEKYC';
import MyFundRequestReport from '../components/reports/fundRequestPartnerReports';
import PayoutService from '../components/payoutService';
import MatmReport from '../components/reports/matmReport';
import PrepaidReports from '../components/reports/prepaidReports/index';
import AepsHistoryReport from '../components/reports/aepsHistory';
import MoneyTransferHistory from '../components/reports/moneyTransfer';
import MoveToBankReport from '../components/settleToBank/move_to_bank_report.js';
import EPayoutHistory from '../components/payout/history';
import PayoutHistory2 from '../components/payoutCashFree/history';

const partnerRoutes = [
  { path: '/settle-to-bank', component: SettleToBank, allowedRoles: ['partner']  },
  { path: '/settle-to-wallet', component: SettleToWallet, allowedRoles: ['partner']  },
  { path: '/aeps', component: fingAepsComponent, allowedRoles: ['partner']  },
  { path: '/express-aeps', component: instantAepsComponent, allowedRoles: ['partner']  },
  { path: '/money-transfer', component: MoneyTransfer, allowedRoles: ['partner']  },
  { path: '/matm-registration', component: RegisterMatm, allowedRoles: ['partner']  },
  { path: '/mobile-recharge', component: mobileRecharge, allowedRoles: ['partner']  },
  { path: '/uitility-payment', component: uitilityPayment, allowedRoles: ['partner']  },
  { path: '/uitility-payment-2-0', component: uitilityPayment2, allowedRoles: ['partner']  },
  { path: '/bharat-billpay-bbps', component: BharatBillpay, allowedRoles: ['partner']  },
  { path: '/bank-setting', component: BankSetting, allowedRoles: ['partner']  },
  { path: '/partner-ekyc', component: PartnerEKYC, allowedRoles: ['partner']  },
  { path: '/myfund-request-report', component: MyFundRequestReport, allowedRoles: ['partner']  },
  { path: '/payout-service', component: PayoutService, allowedRoles: ['partner']  },
  { path: '/commission-release', component: CommissionRelease, allowedRoles: ['partner']  },
  { path: '/matm-report', component: MatmReport, allowedRoles: ['partner']  },
  { path: '/prepaid-reports', component: PrepaidReports, allowedRoles: ['partner']  },
  { path: '/aeps-history-report', component: AepsHistoryReport, allowedRoles: ['partner']  },
  { path: '/money-transfer-history', component: MoneyTransferHistory, allowedRoles: ['partner']  },
  { path: '/move-to-bank', component: MoveToBank, allowedRoles: ['partner'] },
  { path: '/move-to-bank-report', component: MoveToBankReport, allowedRoles: ['partner'] },
  { path: '/remittance-transfer-report', component: EPayoutHistory, allowedRoles: ['partner'] },
  { path: '/PayoutHistory2',component: PayoutHistory2, allowedRoles: ['partner'] }
];

export default partnerRoutes;
